export enum BankRegNr {
    SKUE = '2351',
    BANK2 = '9615',
    HAUGESUND = '3240',
    PENNI = '9812',
    NORD_DIREKTE = '2606',
}
